(ns frontend.ui.component.lp-portal.section.view
  (:require
   [frontend.ui.component.lp-portal.section.style :as style]
   [herb.core :refer [<class]]))

(defn section
  [title id & children]
  [:div
   (merge {:class (<class style/section)}
          (when id
            {:id id}))
   [:div
    {:class (<class style/header)}
    title]
   (into [:div
          {:class (<class style/content)}]
         children)])
